// Alphanumeric Kewill SID values such as 0001589153, AKM0011385, or H4000-L57635-OB.
const KEWILL_SID_VALUE_PATTERN = /^(?=[A-Z0-9-]*\d)[A-Z0-9]+(?:-[A-Z0-9]+)*$/i;
const KEWILL_LABELED_SID_PATTERN =
  /\bSID(?:\s+Number)?\s*(?::|#)?\s+((?=[A-Z0-9-]*\d)[A-Z0-9]+(?:-[A-Z0-9]+)*)\b/i;

// Accepts an exact SID or a value explicitly labeled SID / SID Number.
export function normalizeKewillSID(raw: string): string {
  const trimmed = raw.trim();
  if (KEWILL_SID_VALUE_PATTERN.test(trimmed)) {
    return trimmed.toUpperCase();
  }

  const sid = trimmed.match(KEWILL_LABELED_SID_PATTERN)?.[1];

  return sid?.toUpperCase() ?? '';
}
